<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>For Jason, Jordan, and Savannah</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedt.vue?60d30baa